<script setup lang="ts">
import Notice from '@/components/common/Notice.vue'
</script>

<template>
  <div class="fixed inset-0 z-50 flex flex-col items-center justify-center space-y-8 bg-background">

    <div class="max-w-xs lg:max-w-prose mx-auto">

      <svg class="h-auto md:max-h-10 w-full max-w-fit" data-name="Logo"
        xmlns="http://www.w3.org/2000/svg" align="left" viewBox="0 0 311.81 37.68" preserveAspectRatio="xMinYMin">
        <g class="letters-bold text-primary">
          <path fill="currentColor" class="cls-2" d="m9.91,9.91v4.46h10.91v8.43h-10.91v13.88H0V.99h22.31v8.92h-12.39Z" />
          <path fill="currentColor" class="cls-2" d="m24.3,36.68V.99h9.91v35.69h-9.91Z" />
          <path fill="currentColor" class="cls-2" d="m53.06,9.91v26.77h-9.91V9.91h-7.44V.99h24.79v8.92h-7.44Z" />
          <path fill="currentColor" class="cls-2"
            d="m83.32,36.68l-11.3-16.85h-.1v16.85h-9.91V.99h8.92l11.3,16.86h.1V.99h9.92v35.69h-8.92Z" />
          <path fill="currentColor" class="cls-2"
            d="m118.53,36.68h-22.31V.99h22.31v8.92h-12.39v4.46h10.91v8.43h-10.91v4.96h12.39v8.92Z" />
          <path fill="currentColor" class="cls-2"
            d="m133.67,37.68c-4.71,0-8.92-.99-12.89-3.97l4.56-7.58,3.12,1.83c2.98,1.74,6.69,1.54,6.69-1.19,0-4.96-13.39-4.46-13.39-15.86,0-6.94,5.45-10.91,11.9-10.91,3.92,0,7.09.55,10.41,3.27l-3.37,7.83c-5.06-4.66-9.52-3.17-9.52-.2,0,3.96,13.88,3.47,13.88,15.86,0,6.94-4.46,10.91-11.4,10.91Z" />
          <path fill="currentColor" class="cls-2"
            d="m158.96,37.68c-4.71,0-8.92-.99-12.89-3.97l4.56-7.58,3.12,1.83c2.97,1.74,6.69,1.54,6.69-1.19,0-4.96-13.39-4.46-13.39-15.86,0-6.94,5.45-10.91,11.9-10.91,3.92,0,7.09.55,10.41,3.27l-3.37,7.83c-5.06-4.66-9.52-3.17-9.52-.2,0,3.96,13.88,3.47,13.88,15.86,0,6.94-4.46,10.91-11.4,10.91Z" />
        </g>
        <g class="letters-thin text-secondary dark:text-white">
          <path fill="currentColor" class="cls-1"
            d="m195.26,36.68l-10.66-15.86h-.99v15.86h-3.72V.99h7.68c5.7,0,10.91,2.98,10.91,9.91s-5.21,9.42-9.67,9.92l11.15,15.86h-4.71Zm-7.68-32.22h-3.97v12.89h3.97c3.72,0,7.19-1.49,7.19-6.45s-3.47-6.44-7.19-6.44Z" />
          <path fill="currentColor" class="cls-1"
            d="m219.56,37.68c-10.41,0-17.35-7.93-17.35-18.84S209.15,0,219.56,0s17.35,7.93,17.35,18.84-6.94,18.84-17.35,18.84Zm0-34.21c-7.93,0-13.63,6.94-13.63,15.37s5.7,15.37,13.63,15.37,13.63-6.94,13.63-15.37-5.7-15.37-13.63-15.37Z" />
          <path fill="currentColor" class="cls-1"
            d="m257.26,37.68c-10.41,0-17.35-7.93-17.35-18.84S246.85,0,257.26,0s17.35,7.93,17.35,18.84-6.94,18.84-17.35,18.84Zm0-34.21c-7.93,0-13.63,6.94-13.63,15.37s5.7,15.37,13.63,15.37,13.63-6.94,13.63-15.37-5.7-15.37-13.63-15.37Z" />
          <path fill="currentColor" class="cls-1"
            d="m308.09,36.68V8.43h-.1l-12.3,23.3-12.29-23.3h-.1v28.26h-3.72V.99h3.72l12.39,23.55,12.39-23.55h3.72v35.69h-3.72Z" />
        </g>
      </svg>

    </div>

    <div
      class="progress-ui progress-ui--indeterminate w-56 mx-auto"
      role="progressbar"
      aria-label="Loading"
    >
      <span class="progress-ui__value" />
    </div>

    <Notice inline />

  </div>
</template>
